//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from "jquery";
import { mapState } from "vuex";
import FooterData from "~/content/data/footer.json";
import LocationDropdown from "~/components/menu/LocationDropdown";

export default {
  name: "PageFooter",
  data() {
    return {
      activeSpan: 0,
      sticky: false,
      attached: true,
      footerAnchorAt: 50,
      footerAnchorOffAt: 0,
    };
  },
  components: {
    LocationDropdown,
  },
  computed: {
    ...mapState({
      page: (state) => state.pages.page,
    }),
    theme() {
      if (this.page && this.page.footer)
        return "footer-" + (this.page.footer.theme || "light");
      return "footer-default";
    },
    footerLocation() {
      return this.page.region || "Australia";
    },
    footer() {
      return FooterData;
    },
    yearToday() {
      return 2022;
      // return (new Date()).getYear() + 1900;
    },
    addGradient() {
      return false;
      // return (['index']).includes(this.page.slug);
    },
    footerShowAt() {
      // const isHomePage = (['index']).includes(this.page.slug);

      // if(isHomePage){
      //   if(window.innerHeight < 900) return document.querySelector('[data-section="stat-capsule"]').nextSibling.offsetTop - window.innerHeight + 100;
      //
      //  return document.querySelector('[data-section="stat-capsule"]').nextSibling.offsetTop - window.innerHeight + 100;
      // }

      return 127;
    },
    textsToRotate() {
      const value = this.footer.cta.title;
      let endString = "";
      const matches = value
        .split("[")
        .filter(function (v) {
          return v.includes("]") > -1;
        })
        .map(function (value) {
          if (value) {
            const valueSplit = value.split("]");
            endString = valueSplit[1];
            return valueSplit[0];
          }
          return "";
        });

      if (matches.length === 1) return matches[0];

      return {
        start: matches[0],
        spans: matches[1].split(","),
        end: endString,
      };
    },
    _footerLogo() {
      if (this.theme === "footer-dark")
        return require("~/assets/images/burst-logo-kudo-white.svg");
      return require("~/assets/images/burst-logo-kudo.svg");
    },
    homeUrl() {
      if (this.footerLocation === "United Kingdom") return "https://www.burstsms.co.uk";
      if (this.footerLocation === "United States") return "https://burstsms.com";
      if (this.footerLocation === "New Zealand") return "https://burstsms.co.nz";
      if (this.footerLocation === "Philippines") return "https://burstsms.com.ph";
      if (this.footerLocation === "Hong Kong") return "https://www.burstsms.com.hk";
      if (this.footerLocation === "Canada") return "https://www.burstsms.ca";
      if (this.footerLocation === "Singapore") return "https://www.burstsms.com.sg";
      if (this.footerLocation === "Australia") return "https://www.burstsms.com.au";

      return "https://burstsms.com/";
    },
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    $(".row-menu .col-menu").on("click", function () {
      $(this).toggleClass("open");
      $(this).siblings().removeClass("open");
    });
  },
  created() {
    if (process.browser || process.client) {
      const self = this;
      this.$nextTick(function () {
        setInterval(function () {
          self.activeSpan++;
          if (self.activeSpan >= self.textsToRotate.spans.length) self.activeSpan = 0;
        }, 5000);
      });
    }
  },
  methods: {
    isRelative(url) {
      const r = new RegExp("^(?:[a-z]+:)?//", "i");
      return !r.test(url);
    },
    handleScroll() {
      const scrollY = $(window).scrollTop();
      const footerAnchor = document.querySelector(".footer-anchor");
      const footer = document.querySelector("footer");
      const footerPadTop = parseFloat(
        window.getComputedStyle(footer, null).getPropertyValue("padding-top")
      );
      const footerAnchorOffAt =
        footer.offsetTop - window.innerHeight + footerPadTop + footerAnchor.clientHeight;

      this.sticky = scrollY >= this.footerShowAt;
      this.attached = scrollY >= footerAnchorOffAt;
    },
  },
};
